import { c as _c } from "react/compiler-runtime";
import { useUser } from '@auth0/nextjs-auth0';
import { useState } from 'react';
import { TRPC_SETTINGS } from '~/constants/trpc';
import { api } from '~/libs/api';
import { useSharedRouter } from '~/utils/nextMigration/router';
export const useTripSave = tripId => {
  const $ = _c(19);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const {
    user
  } = useUser();
  const router = useSharedRouter();
  const saveTrip = api.account.saveTrip.useMutation();
  const removeTrip = api.account.removeTrip.useMutation();
  const t0 = tripId ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      tripId: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!user && !!tripId;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      enabled: t2,
      ...TRPC_SETTINGS.QUERY_NO_REFETCH
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: isTripSaved,
    refetch
  } = api.account.isTripSaved.useQuery(t1, t3);
  let t4;
  if ($[4] !== isTripSaved || $[5] !== refetch || $[6] !== removeTrip || $[7] !== saveTrip || $[8] !== tripId || $[9] !== user) {
    t4 = async () => {
      if (!tripId) {
        return;
      }
      if (!user) {
        setIsLoginOpen(true);
        return;
      }
      if (isTripSaved) {
        await removeTrip.mutateAsync({
          tripId
        });
      } else {
        await saveTrip.mutateAsync({
          tripId,
          notify: true,
          tripPageUrl: typeof window !== "undefined" ? window.location.href : ""
        });
      }
      refetch();
    };
    $[4] = isTripSaved;
    $[5] = refetch;
    $[6] = removeTrip;
    $[7] = saveTrip;
    $[8] = tripId;
    $[9] = user;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleSave = t4;
  let t5;
  if ($[11] !== router || $[12] !== tripId) {
    t5 = () => {
      if (!tripId) {
        return;
      }
      router.push(`/auth/login?returnTo=/account?tripId=${tripId}`);
    };
    $[11] = router;
    $[12] = tripId;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const handleLogin = t5;
  let t6;
  if ($[14] !== handleLogin || $[15] !== handleSave || $[16] !== isLoginOpen || $[17] !== isTripSaved) {
    t6 = {
      isTripSaved,
      isLoginOpen,
      setIsLoginOpen,
      handleSave,
      handleLogin
    };
    $[14] = handleLogin;
    $[15] = handleSave;
    $[16] = isLoginOpen;
    $[17] = isTripSaved;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};